import { InjectionToken } from '@angular/core';

export const LXLIB_LOCALE = new InjectionToken<string>('lxlib-locale');
